export default "__VITE_ASSET__wxHGmydz__"